export enum ETableSortColumn {
  NAME = 'fullName',
  TYPE = 'CompanyType',
  CREATED = 'createdDate',
  PUBLISHED = 'publishedDate',
}
